<template>
  <!-- 修改密码 -->
  <div class="container">
    <div class="vue">
      <div class="header">
        <div class="text">修改密码</div>
      </div>
      <div class="content flex">
        <div class="left"></div>
        <div class="right FZ0875">
          <div class="form flex">
            <span>原密码</span>
            <el-input
              v-model="form.password"
              size="small"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div class="form flex">
            <span>新密码</span>
            <el-input
              v-model="form.newpassword"
              size="small"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div class="form flex">
            <span>再次输入新密码</span>
            <el-input
              v-model="form.newpassword2"
              size="small"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div class="form but flex">
            <span></span>
            <div class="button flex">
              <el-button
                class="sure"
                size="small"
                type="primary"
                @click="confirmBut"
                >保存</el-button
              >
              <el-button
                class="sure"
                @click="clearBut"
                type="info"
                size="small"
                plain
                >放弃</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiChangePwd } from '@/api/ControlPane'
export default {
  name: '',
  props: [''],
  data() {
    return {
      form: {
        password: '',
        newpassword: '',
        newpassword2: ''
      },
      list: [
        '原密码不能为空哦！',
        '新密码不能为空哦！',
        '再次输入密码不能为空哦！'
      ]
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    // 保存
    confirmBut() {
      if (this.objNaN(this.form, this.list)) {
      } else {
        if (this.form.newpassword !== this.form.newpassword2) {
          this.$message.error('新密码两次输入不一致')
          return
        }
        apiChangePwd({
          adPassword: this.form.password,
          newPassword: this.form.newpassword
        }).then(res => {
          if (res.status === 0) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.form = {
              password: '',
              newpassword: '',
              newpassword2: ''
            }
          } else if (res.status === 1) {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 放弃
    clearBut() {
      this.form = {
        password: '',
        newpassword: '',
        newpassword2: ''
      }
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    border-bottom: 1px solid #f2f2f2;
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    .left {
      width: 40%;
    }
    .right {
      width: 60%;
      .form {
        width: 100%;
        align-items: center;
        justify-content: flex-start;
        padding-bottom: 10px;
        span {
          text-align: right;
          width: 18%;
          margin-right: 10px;
        }
        .button,
        .el-input {
          width: 82%;
        }
        .el-button {
          padding: 8px 20px;
        }
      }
      .but {
        padding-top: 20px;
      }
    }
  }
}
</style>
